<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">编辑项目经历</span>
      </p>
      <p style="padding-right: 2rem;color: #FFFFFF " @click="delEditProjecter()">删除</p>
    </header>
    <div class="personalMain">
      <!--<div class="inforName">-->
      <!--&lt;!&ndash;<van-cell-group>&ndash;&gt;-->
      <!--<van-field label="公司名称" color="#DEDEDE"  readonly />-->
      <!--<van-field   value="达达快递" placeholder="1994.03" />-->
      <!--</div>-->
      <div class="inforName">
        <p class="inforNameTop">项目名称</p>
        <p> <input class="inforNameInput" type="text" value="cc星球" v-model="list.proname"></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop" >项目描述</p>
        <p >
          <textarea style="width: 100%;height: 5rem" v-model="list.prodescription"></textarea>
        </p>
      </div>
      <div class="inforName">
        <p class="inforNameTop" >项目责任</p>
        <p >
          <textarea style="width: 100%;height: 5rem" v-model="list.dutydescription"></textarea>
        </p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">项目时间</p>
        <p style="display: flex"><input class="inforTime" v-model="list.starttime" type="text"><span>--</span>
          <input class="inforTime" v-model="list.endtime" type="text" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">项目链接</p>
        <p><input class="inforNameInput" type="text" value="www.baidu.com" v-model="list.projecturl"></p>
      </div>
      <div>

      </div>
      <div class="inforName">
        <van-button style="width: 100%;margin: 0 auto" type="primary" @click="saveEditProjecter()">保存</van-button>

      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        list:{}
      }
    },
    mounted(){
      this.getEditProjecter()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      getEditProjecter(){
        console.log(this.data)
        this.$api.getEditProject({id:this.$route.params.id}).then(res=>{
          if(res.status==200){
            this.list=res.data;
          }
        }).catch(err=>{
        })
      },
      saveEditProjecter(){
        console.log(this.data)
        this.$api.saveEditProject({
          "data[proname]":this.list.proname,
          "data[prodescription]":this.list.prodescription,
          "data[dutydescription]":this.list.dutydescription,
          "data[starttime]":this.list.starttime,
          "data[endtime]":this.list.endtime,
          "data[projecturl]":this.list.projecturl,
          "id":this.$route.params.id,
        }).then(res=>{

        }).catch(err=>{
        })
      },
      delEditProjecter(){
        console.log(this.data)
        this.$router.push("/editResume")
//        this.$api.delEditProject({
//          "id":this.$route.params.id,
//        }).then(res=>{
//            if(res.status==200){
//
//            }
//        }).catch(err=>{
//        })
      },
    }
  }
</script>
<style scoped>
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 8rem 18px 0 18px;
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
  /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    font-size: 13px;
    color: grey;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/editProject.vue